var _style, _g, _path, _path2, _path3, _polygon, _path4, _path5, _rect, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChiaSeeds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#FEE8CE;}\n\t.st2{fill:#231612;}\n\t.st3{fill:#5F4848;}\n\t.st4{fill:#C4AAA4;}\n\t.st5{fill:#82605A;}\n\t.st6{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.7,107.17c0,5.13-0.51,10.17-1.5,15.03c-7.02,35.13-38.31,61.59-75.81,61.59 c-42.69,0-77.28-34.29-77.28-76.62c0-42.3,34.59-76.59,77.28-76.59c38.58,0,70.59,28.02,76.35,64.65 C184.37,99.13,184.7,103.12,184.7,107.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 92.33,
    cy: 108.72,
    rx: 45.64,
    ry: 30.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.7,107.17c0,5.13-0.51,10.17-1.5,15.03h-52.11c-7.41,0-13.47-6.06-13.47-13.47 c0-3.72,1.53-7.11,3.96-9.54s5.79-3.96,9.51-3.96h52.65C184.37,99.13,184.7,103.12,184.7,107.17z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9765 -0.2153 0.2153 0.9765 -19.5714 19.1398)",
    className: "st2",
    cx: 78.05,
    cy: 99.39,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9938 -0.1111 0.1111 0.9938 -9.9291 9.696)",
    className: "st3",
    cx: 82.03,
    cy: 93.94,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 86.93,
    cy: 98.65,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2265 -0.974 0.974 0.2265 -20.4419 164.9926)",
    className: "st5",
    cx: 93.66,
    cy: 95.37,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9991 -0.0424 0.0424 0.9991 -4.676 3.131)",
    className: "st2",
    cx: 71.41,
    cy: 111.7,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5108 -0.8597 0.8597 0.5108 -54.6729 115.0251)",
    className: "st3",
    cx: 73.74,
    cy: 105.56,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6441 -0.7649 0.7649 0.6441 -49.8178 88.1701)",
    className: "st4",
    cx: 69.85,
    cy: 97.63,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7682 -0.6402 0.6402 0.7682 -51.3565 65.9863)",
    className: "st5",
    cx: 65.44,
    cy: 103.91,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 80.97,
    cy: 110.67,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9545 -0.2983 0.2983 0.9545 -30.6684 32.0987)",
    className: "st2",
    cx: 89.84,
    cy: 116.54,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9806 -0.1959 0.1959 0.9806 -22.286 19.2824)",
    className: "st3",
    cx: 86.34,
    cy: 122.31,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9963 -0.0857 0.0857 0.9963 -9.8187 7.3825)",
    className: "st4",
    cx: 81.06,
    cy: 118.03,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1422 -0.9898 0.9898 0.1422 -57.5423 180.1496)",
    className: "st5",
    cx: 75.17,
    cy: 123.27,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9918 -0.1279 0.1279 0.9918 -12.4824 13.0567)",
    className: "st2",
    cx: 95.41,
    cy: 103.7,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4353 -0.9003 0.9003 0.4353 -46.1907 146.407)",
    className: "st3",
    cx: 93.61,
    cy: 110.02,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5762 -0.8173 0.8173 0.5762 -54.5059 130.0636)",
    className: "st4",
    cx: 98.16,
    cy: 117.59,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7105 -0.7037 0.7037 0.7105 -48.5415 103.911)",
    className: "st5",
    cx: 102.01,
    cy: 110.95,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9963 -0.0857 0.0857 0.9963 -8.7307 7.7568)",
    className: "st4",
    cx: 85.96,
    cy: 105.55,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -0.0101 0.0101 0.9999 -1.0423 1.1404)",
    className: "st2",
    cx: 112.52,
    cy: 103.9,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0955 -0.9954 0.9954 0.0955 -9.1501 201.9676)",
    className: "st3",
    cx: 106.56,
    cy: 106.02,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 88.22,
    cy: 90.04,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4218 -0.9067 0.9067 0.4218 -51.6786 164.0591)",
    className: "st5",
    cx: 102.8,
    cy: 122.55,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -32.8306 135.3389)",
    className: "st2",
    cx: 100.79,
    cy: 96.1,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6766 -0.7364 0.7364 0.6766 -37.6182 110.0044)",
    className: "st3",
    cx: 106.42,
    cy: 97.83,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8043 -0.5942 0.5942 0.8043 -46.2211 87.8771)",
    className: "st4",
    cx: 110.3,
    cy: 114.11,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4427 -0.8967 0.8967 0.4427 -20.8948 146.8763)",
    className: "st5",
    cx: 107.71,
    cy: 90.25,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2055 -0.9787 0.9787 0.2055 -62.2144 149.9657)",
    className: "st4",
    cx: 61.25,
    cy: 113.3,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4353 -0.9003 0.9003 0.4353 -66.5322 127.5436)",
    className: "st3",
    cx: 68.4,
    cy: 116.81,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2468 -0.9691 0.9691 0.2468 -52.1644 185.6392)",
    className: "st2",
    cx: 93.34,
    cy: 126.38,
    rx: 2.36,
    ry: 4.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 73.96,
    cy: 90.63,
    rx: 4.25,
    ry: 2.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1027 -0.9947 0.9947 0.1027 -53.4159 197.8548)",
    className: "st3",
    cx: 82.96,
    cy: 128.54,
    rx: 2.36,
    ry: 4.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.35,92.73c0-0.04-0.01-0.08-0.01-0.11C115.35,92.66,115.35,92.7,115.35,92.73L115.35,92.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.12,91.16L115.12,91.16c0.02,0.08,0.03,0.17,0.04,0.25C115.15,91.33,115.14,91.25,115.12,91.16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.55,89.14c-0.02-0.07-0.05-0.13-0.07-0.2C114.5,89.01,114.53,89.07,114.55,89.14L114.55,89.14z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "113.62,101.26 113.62,101.26 113.62,101.27 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.33,95.81c0,0.02,0,0.04-0.01,0.07C115.32,95.85,115.32,95.83,115.33,95.81z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112.23,103.39L112.23,103.39c-0.26,0.33-0.53,0.66-0.83,0.98C111.69,104.05,111.96,103.72,112.23,103.39z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 102.42,
    transform: "matrix(0.9996 -0.029 0.029 0.9996 -2.9222 3.3176)",
    className: "st6",
    width: 0,
    height: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.08,97.34c-0.01,0.02-0.01,0.04-0.02,0.07C115.07,97.38,115.07,97.36,115.08,97.34z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.42,94.27c0,0.01,0,0.02,0,0.03C115.42,94.29,115.42,94.28,115.42,94.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiaSeeds);
export default __webpack_public_path__ + "static/media/Chia_seeds.17e2fbc0310daa965f6d6f456508ba18.svg";
export { ForwardRef as ReactComponent };